export const acceptableLocales = ["en-US", "en-AU", "en-GB", "en-IE", "en-NZ", "en-ZA"]